import './DetailSubsection.scss';
import classNames from 'classnames';
import { getTitleWithCount } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { Row, Space } from 'antd';
export const DetailSubsection = ({ children, count, headerSpaceAlign = 'center', hidden, className, spacing = 'medium', title, titleExtra }) => {
    if (hidden) {
        return null;
    }
    return (React.createElement("div", { className: classNames('detail-subsection', className) },
        React.createElement(Row, { align: 'middle', className: 'h3 detail-subsection-header' },
            React.createElement(Space, { align: headerSpaceAlign },
                React.createElement("span", { className: 'detail-subsection-title' }, getTitleWithCount(title, count)),
                titleExtra)),
        React.createElement("div", { className: classNames('detail-subsection-body', {
                'detail-subsection-body-large-spacing': spacing === 'large',
                'detail-subsection-body-no-spacing': spacing === 'none',
                'detail-subsection-body-small-spacing': spacing === 'small'
            }) }, children)));
};
